<template>
    <tr @click.stop.prevent="goToDetail()">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
          <input type="checkbox"
                 :id="entity.id"
                 :value="entity.id"
                 @change="onChange"
                 :checked="isChecked"
                 @click.stop
          />
          <label :for="entity.id" @click.stop v-translate>Vybrat</label>
        </td>
      <td class="first_data" data-th="Název">
        <strong v-if="entity.video_exists && vodDetailAllowed">{{ entity.name }}</strong>
        <strong v-else>
          {{ entity.name }}
        </strong>
      </td>
        <td data-th="Cena">{{entity.price }}</td>
        <td data-th="Zařízení">
          <entity-link v-if="entity.device_name" :id="entity.id_device" type="device">{{ entity.device_name }}</entity-link>
        </td>
        <td data-th="Profil">
          <entity-link v-if="entity.subscriber_profile_name" :id="entity.id_subscriber_profile" type="subscriberProfile">{{ entity.subscriber_profile_name }}</entity-link>
        </td>
        <td data-th="Čas zakoupení" v-html="$_date_formatFull(entity.purchase_timestamp)"></td>
        <td class="no_padding edit">
        </td>
    </tr>
</template>

<script>
import EntityLink from "../../../common/EntityLink.vue";

export default {
		name: "entityRow",
    components: { EntityLink },
		props: {
			entity: Object,
      selectedEntities: Array,
      vodDetailAllowed: Boolean,
		},
        methods: {
          onChange: function (e) {
            this.$emit('input', e)
          },
          goToDetail(){
            this.$router.push({name: 'vodVideosDetail', params: {id: this.entity.id_vod_video}});
          },
        },
        computed: {
          isChecked() {
            return this.selectedEntities.indexOf(String(this.entity.id)) > -1
          }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/purchasedVodVideos/PurchasedVodVideosRow.vue